export const COVER_PRESET_UI: { key: string; label: string; bg: string }[] = [
  { key: 'teal', label: '青绿', bg: '#0f766e' },
  { key: 'navy', label: '深蓝', bg: '#1e3a5f' },
  { key: 'slate', label: '岩灰', bg: '#334155' },
  { key: 'forest', label: '墨绿', bg: '#14532d' },
  { key: 'ink', label: '墨黑', bg: '#0f172a' },
  { key: 'amber', label: '琥珀', bg: '#92400e' },
];

export type CoverConfig = {
  enabled: boolean;
  color_mode: 'fixed' | 'rotate' | 'random';
  preset: string;
  /** 轮换/随机时服务端记录的「上次已用配色」 */
  last_preset?: string;
  palette?: string[];
  title_mode: 'auto' | 'custom';
  title_template: string;
  show_date: boolean;
  show_accent: boolean;
};

export function defaultCover(): CoverConfig {
  return {
    enabled: true,
    color_mode: 'rotate',
    preset: 'teal',
    last_preset: '',
    palette: COVER_PRESET_UI.map((p) => p.key),
    title_mode: 'auto',
    title_template: '{site_name}',
    show_date: true,
    show_accent: true,
  };
}

export function mergeCoverFromApi(raw: unknown): CoverConfig {
  const d = defaultCover();
  if (!raw || typeof raw !== 'object') return d;
  const c = raw as Record<string, unknown>;
  const mode = String(c.color_mode || '');
  const titleMode = String(c.title_mode || '');
  const paletteRaw = Array.isArray(c.palette)
    ? c.palette.map((x) => String(x).trim()).filter(Boolean)
    : d.palette;
  const palette = paletteRaw?.filter((k) => COVER_PRESET_UI.some((p) => p.key === k));
  return {
    enabled: c.enabled === undefined ? d.enabled : Boolean(c.enabled),
    color_mode: mode === 'fixed' || mode === 'random' ? mode : 'rotate',
    preset: typeof c.preset === 'string' && c.preset.trim() ? c.preset.trim() : d.preset,
    last_preset: typeof c.last_preset === 'string' ? c.last_preset.trim() : '',
    palette: palette && palette.length > 0 ? palette : d.palette,
    title_mode: titleMode === 'custom' ? 'custom' : 'auto',
    title_template:
      typeof c.title_template === 'string' && c.title_template.trim()
        ? c.title_template.trim().slice(0, 40)
        : d.title_template,
    show_date: c.show_date === undefined ? d.show_date : Boolean(c.show_date),
    show_accent: c.show_accent === undefined ? d.show_accent : Boolean(c.show_accent),
  };
}

/** 与 api/lib/oa_mass_cover.php 中 wes_oa_mass_cover_resolve_for_run 对齐，用于编辑页预览「下次推送」配色 */
export function resolveCoverPreviewPreset(cover: CoverConfig): { key: string; bg: string; label: string } {
  const palette =
    cover.palette && cover.palette.length > 0 ? cover.palette : COVER_PRESET_UI.map((p) => p.key);
  const last = (cover.last_preset || '').trim();
  let picked = cover.preset || palette[0] || 'teal';

  if (cover.color_mode === 'rotate') {
    const idx = palette.indexOf(last);
    picked = idx === -1 ? palette[0] : palette[(idx + 1) % palette.length];
  } else if (cover.color_mode === 'random') {
    const candidates = palette.length > 1 && last !== '' ? palette.filter((k) => k !== last) : palette;
    picked = candidates[0] ?? palette[0];
  } else {
    picked = cover.preset || palette[0] || 'teal';
  }

  const row = COVER_PRESET_UI.find((p) => p.key === picked) || COVER_PRESET_UI[0];
  return { key: row.key, bg: row.bg, label: row.label };
}
